import { createSelector } from 'reselect'
import { getVillaViews } from '../view/villa'
import { nonNullable, sum } from 'lib/array/arrayUtils'
import { mergeFees } from 'checkout/lib/utils/payments/fees'
import {
  checkoutWithMemberPrice,
  getHasLuxPlusOrSubscriptionInCart,
} from 'checkout/selectors/view/luxPlusSubscription'

export const getVillaTotals = createSelector(
  (state: App.State) => getVillaViews(state),
  (state: App.State) => checkoutWithMemberPrice(state),
  (state: App.State) => getHasLuxPlusOrSubscriptionInCart(state),
  (views, checkoutWithMemberPrice, hasLuxPlusOrSubscriptionInCart): App.WithDataStatus<App.Checkout.ItemViewTotals> => {
    const price = sum(views.data, data => data.totals.price)
    const memberPrice = sum(views.data, data => data.totals.memberPrice)
    const value = sum(views.data, data => data.totals.value)
    const memberValue = sum(views.data, data => data.totals.memberValue)
    return {
      hasRequiredData: views.hasRequiredData,
      data: {
        price: checkoutWithMemberPrice && memberPrice > 0 ? memberPrice : price,
        memberPrice,
        value: hasLuxPlusOrSubscriptionInCart ? memberValue : value,
        surcharge: sum(views.data, data => data.totals.surcharge),
        taxesAndFees: sum(views.data, data => data.totals.taxesAndFees),
        propertiesFees: nonNullable(views.data.flatMap(data => data.totals.propertiesFees)),
        otherFees: mergeFees(nonNullable(views.data.flatMap(data => data.totals.otherFees))),
        // NB: `addTotals` ignores this.
        memberValue: 0,
        extraGuestSurcharge: 0,
      },
    }
  },
)
